<div class="sign-container">
  <canvas
    #canvas
    (touchstart)="startDrawing($event)"
    (touchmove)="moved($event)"
  ></canvas>
  <button *ngIf="showDelete" (click)="clearPad()" class="clear-assign-btn">
    {{ "RDV_PAGE.ASSIGN.DROP_ASSIGN_IMG" | translate }}
  </button>
</div>
